<template>
	<side-window class="employee" title="Geofence" @pop="$emit('pop')" @close="$emit('close')">
		<div>
			<form-grid-layout>
				<div>
					<string-view name="label"  label="Label" v-model="entity.label" />
				</div>
				<div>
					<string-view name="make"  label="Længdegrad" v-model="entity.lng" />
					<string-view name="model" label="Breddegrad" v-model="entity.lat" />
				</div>
				<div>
					<string-view name="make"  label="Afstand [m]" v-model="entity.dist" />
					<string-view name="model" label="Hysterese [m]" v-model="entity.hyst" />
				</div>
				<div>
					<div class="side-window__heading">
						Check-in
						<switch-view v-model="entity.checkin" />
					</div>
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Gem" @click="create" />
		</div>
		<div v-if="form && id" @click="update" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	export default {
		data: function () {
			return {
				entity: {
					//class: 'business',
					//country_id: 1,
					//invoice_contact_id: null
					label: '',
					lat: '',
					lng: '',
					dist: '',
					hyst: '',
					checkin: false
				},
				vehicles: []
			};
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		computed: {
			_vehicles() {
				var r = [{
					name: 'Ingen',
					id: null
				}];

				for (var i = 0; i < this.vehicles.length; ++i) {
					r.push(this.vehicles[i]);
				}

				return r;
			}
		},
		methods: {
			create() {
				var win = this;

				
				

				this.axios
					.post('/tracking/geofencing/', this.entity)
					.then(function (r) {
						

						if (r.status == 200) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			async update() {
				
				

				var win = this;

				this.axios
					.put('/tracking/geofencing/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 || r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: async function() {
			
			

			var win = this;

			if (this.id) {
				this.axios
					.get('/tracking/geofencing/' + this.id + '/')
					.then(function (r) {
						win.entity = r.data;
					});
			}

			this.vehicles = (await this.axios.get('/fleet/vehicles/all/')).data._items;

			
		}
	}
</script>

<style lang="scss">
	
</style>
